import { render, staticRenderFns } from "./FactorUnitList.vue?vue&type=template&id=36fa1130&scoped=true&"
import script from "./FactorUnitList.vue?vue&type=script&lang=js&"
export * from "./FactorUnitList.vue?vue&type=script&lang=js&"
import style0 from "./FactorUnitList.vue?vue&type=style&index=0&id=36fa1130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa1130",
  null
  
)

export default component.exports